<template>
	<div :class="'freeUserTips free-usertips-bg' + bgtype">
		<div class="freeUserTips-opbg container-flex-center">
			<div class="freeUserTips-con" >
				<h5 class="title tac orangefont fz24 lh48 mt-2" v-if="type != 4">温馨提示</h5>
				<p class="tac fz16 lh28 orangefont" v-if="type == 1">您的试用时间已到期，如需延期请即刻与我们联系<br> 升级为正式账号，即可享受完整权益</p>
				<p class="tac fz16 lh28 orangefont mt-2" v-if="type == 2">升级为正式账号，即可享受完整权益</p>
				<p class="tac fz16 lh28 orangefont" v-if="type == 3">成为SVIP， 即可享受产业链分析报告下载功能</p>
				<!-- <p class="tac fz16 lh28 orangefont vip-link" v-if="type == 4" @click="routerblank('/order')">开通VIP，即可享受完整权益</p> -->

				<div v-if="type == 4" class="font-16 tips-content mt-2" :class="{'pt-5': type == 4}">
					<p><span class="display-inline-block hover color-5E83CC hover font-bold" @click="routerself('/user-login')">
							<i class="display-inline-block fl mt mr-1">
								<svg t="1732870175604" class="icon" viewBox="0 0 1024 1024" version="1.1"
									xmlns="http://www.w3.org/2000/svg" p-id="7778" width="27" height="27">
									<path
										d="M456.704 508.416c95.232 0 192.512-93.696 192.512-193.024s-92.16-200.192-187.904-200.192C366.08 115.2 271.36 218.624 271.36 317.952s90.112 190.464 185.344 190.464z m41.984 41.472H308.224c-47.616 0-119.296 25.088-142.848 99.328-24.064 74.24-24.064 74.24-47.616 148.992-11.776 37.376 162.816 56.32 336.384 55.808 57.856 0 18.432-47.616 18.432-107.52-0.512-137.216 116.224-196.608 26.112-196.608z"
										p-id="7779" fill="#5E83CC"></path>
									<path
										d="M758.784 492.032c-115.712 0-209.92 93.696-209.92 209.92s93.696 209.92 209.92 209.92 209.92-93.696 209.92-209.92-93.696-209.92-209.92-209.92z m-114.688 200.704c3.072-4.608 8.192-7.68 13.824-7.68h167.936l-44.032-44.032c-5.632-5.632-5.632-14.336 0-19.968s14.336-5.632 19.968 0l70.656 70.656c5.632 5.632 5.632 14.336 0 19.968l-70.656 70.656c-5.632 5.632-14.336 5.632-19.968 0-2.56-2.56-4.096-6.144-4.096-10.24 0-3.584 1.536-7.168 4.096-10.24l44.032-44.032h-167.936c-5.632 0-10.752-3.072-13.824-7.68-2.048-2.56-3.584-5.632-3.584-9.216 0-2.56 1.536-5.632 3.584-8.192z"
										fill="#5E83CC" p-id="7780"></path>
								</svg>
							</i>
							用户登录 > </span>
						<span class="display-inline-block color-5E83CC hover font-bold ml-10"
							@click="openSmWindow('https://wpa1.qq.com/lwDa6cb4?_type=wpa&qidian=true')">
							<i class="display-inline-block fl mt mr-1">
								<svg t="1732870558580" class="icon" viewBox="0 0 1024 1024" version="1.1"
									xmlns="http://www.w3.org/2000/svg" p-id="9966" width="20" height="20">
									<path
										d="M224 480c-52.992 0-96-57.28-96-128 0-64.192 35.456-117.376 81.664-126.592C253.184 112.768 372.096 32 512 32c139.904 0 258.88 80.832 302.336 193.408C860.544 234.624 896 287.808 896 352c0 70.72-43.008 128-96 128H768V320c0-122.112-113.216-224-256-224S256 197.888 256 320v160h-32z m-158.208 512A258.688 258.688 0 0 1 64 960c0-140.8 88.448-263.936 220.288-330.752A382.272 382.272 0 0 0 512 704a382.272 382.272 0 0 0 227.712-74.752C871.552 696.064 960 819.2 960 960c0 11.712-0.64 22.4-1.792 32H65.792zM512 608a224 224 0 1 1 0-448 224 224 0 0 1 0 448z"
										fill="#5E83CC" p-id="9967"></path>
								</svg>
							</i>
							问题咨询 ></span>
					</p>
					<p><span class="display-inline-block redfont font-bold hover" @click="routerself('/orders')">
							<i class="display-inline-block fl mt mr-15">
								<svg t="1732870709649" class="icon" viewBox="0 0 1151 1024" version="1.1"
									xmlns="http://www.w3.org/2000/svg" p-id="13388" width="23" height="23">
									<path
										d="M1088.360553 760.418843h-213.67987a20.984131 20.984131 0 0 1-20.920155-21.112083c0-11.579658 9.340497-21.112083 20.920155-21.112083h213.67987c11.515682 0 20.856179-9.404473 20.856179-21.048107V64.295889a21.048107 21.048107 0 0 0-20.920155-21.112083H62.953081a21.048107 21.048107 0 0 0-20.984131 21.112083v632.850681c0 11.643634 9.404473 21.112083 20.984131 21.112083h337.793327c11.515682 0 20.920155 9.468449 20.920155 21.112083 0 11.643634-9.340497 21.112083-20.920155 21.112083H62.953081a63.080345 63.080345 0 0 1-62.824441-63.336249V64.295889c0-34.930901 28.149444-63.336249 62.824441-63.336249h1025.343496c34.674997 0 62.760465 28.405348 62.760465 63.336249v632.850681c0 34.930901-28.149444 63.336249-62.696489 63.336249"
										fill="#d66262" p-id="13389"></path>
									<path
										d="M313.803012 219.821567c57.578408 0 93.404973 26.486068 93.404973 70.117706 0 31.668124-18.744971 55.339248-48.941647 62.568537 37.425965 6.397601 59.62564 33.267525 59.625641 70.885418 0 48.109959-38.513557 76.963139-101.337999 76.963138H192.952331V219.821567h120.850681zM239.846746 336.065975h71.525178c29.81282 0 47.726103-14.074722 47.726102-37.745845 0-23.607147-17.913283-36.466325-47.726102-36.466325H239.846746v74.21217z m0 122.194177h71.525178c36.594277 0 58.474072-14.394602 58.474072-40.880669 0-24.822691-21.879795-39.665126-58.474072-39.665126H239.846746v80.609771zM710.134388 384.111958c0 73.380482-45.67887 118.291641-120.850681 118.291641-75.107835 0-121.234537-44.911158-121.234537-118.291641V219.821567h46.894414v164.290391c0 47.342247 29.045108 75.747595 74.787955 75.747595 45.295014 0 73.508434-28.021492 73.508434-75.747595V219.821567h46.894415v164.290391M844.995815 500.356366V408.550793l-103.769087-188.729226h47.278271l79.522179 136.652755 77.922779-136.652755h47.662127l-102.105711 187.193802v93.404973zM693.308697 1023.616144c-58.218168 0-133.709859-28.149444-200.37286-52.972136-37.106085-13.882794-72.29289-26.869924-94.428589-30.964388-36.402349-6.589529-57.450456-29.428964-57.770336-62.632513-0.255904-17.913283 6.653505-35.250781 18.872923-47.726102a61.480945 61.480945 0 0 1 44.271398-18.680995l46.190678 1.5994-167.873047-169.216544c-25.97426-26.230164-26.869924-66.407097-1.919281-91.485692 24.246907-24.502811 65.255529-23.671123 90.206173 1.471448l87.263276 87.967012a62.696489 62.696489 0 0 1 78.050731-31.668124 62.504561 62.504561 0 0 1 14.90641-23.799076 62.696489 62.696489 0 0 1 66.599026-13.94677 62.568537 62.568537 0 0 1 14.714482-23.415219c24.182931-24.438835 65.639385-23.351243 90.845933 1.983256l117.715856 118.803449c76.131451 76.771211 45.99875 186.234162 19.384731 233.448457a21.112083 21.112083 0 0 1-3.390729 4.478321l-90.845932 91.485692c-16.633762 16.761714-40.944646 25.270524-72.420843 25.270524z m-289.683368-170.815944a19.832563 19.832563 0 0 0-14.26665 6.205673 24.822691 24.822691 0 0 0-6.781457 17.593402c0 6.077721 0.191928 17.401474 23.287267 21.559915 25.846308 4.670249 60.969137 17.785331 101.593902 32.883669 60.137448 22.455579 135.117331 50.349119 185.850306 50.349119 19.960515 0 34.355117-4.286393 42.863927-12.795202l88.670748-89.374484c8.508809-16.569786 53.611896-112.469824-13.818818-180.412346l-117.843809-118.867424a25.526428 25.526428 0 0 0-17.657378-7.933026 19.320755 19.320755 0 0 0-13.882794 5.949769c-8.700737 8.764713-8.060977 21.751843 1.535424 31.412221a21.176059 21.176059 0 0 1 0 29.81282 20.792203 20.792203 0 0 1-29.620892 0l-21.687867-21.815819a25.462452 25.462452 0 0 0-17.657378-7.933025 19.256779 19.256779 0 0 0-13.882794 5.885793c-8.700737 8.764713-8.124953 21.687867 1.407472 31.348244l0.447832 0.447832H582.310322v0.127952H582.310322v0.063976h0.127952v0.127952h0.063976v0.063976l0.063976 0.063976h0.063976l0.063976 0.127952 0.127952 0.127952v0.063976l0.127952 0.063976v0.063976h0.063976v0.127952h0.063976l0.063976 0.063976 0.063976 0.127952h0.063976v0.063976c1.91928 2.431088 3.1988 5.118081 3.966513 7.997001v0.255904l0.063976 0.127952v0.127952l0.063976 0.063976v0.255904l0.063976 0.063976v0.255904l0.063976 0.063976v0.255905l0.063976 0.063976v0.31988h0.063976v0.31988s0.063976 0 0 0v0.127952h0.063976V659.464701h0.063976V660.104461l0.063976 0.063976V663.111333s0 0.063976 0 0v0.383856s0 0.063976 0 0v0.127952a20.984131 20.984131 0 0 1-15.994003 18.489067 20.536299 20.536299 0 0 1-19.576658-5.565913l-20.984131-21.112083a25.270524 25.270524 0 0 0-17.593403-7.997001 19.192803 19.192803 0 0 0-14.010746 6.013745 19.768587 19.768587 0 0 0-6.077721 14.842434 24.694739 24.694739 0 0 0 7.613145 16.441834l0.063976 0.063976v0.063976h0.063976l0.127952 0.127952v0.063976l0.127953 0.063976 0.063976 0.063976v0.063976h0.063976l0.063976 0.127952c7.549169 8.316881 7.357241 21.176059-0.575785 29.237036a20.792203 20.792203 0 0 1-28.789204 0.703737H472.271586v-0.063976H472.271586l-0.063976-0.063976-0.063976-0.063976-0.063976-0.063976-0.063976-0.063976-0.063976-0.063976-0.127952-0.127952-0.127952-0.127952-130.766962-131.790579c-9.148569-9.276521-22.519555-10.172185-31.09234-1.535424-9.724353 9.788329-6.397601 23.415219 1.983256 31.860052l205.362989 207.026365c6.077721 6.141697 7.805073 15.354242 4.350368 23.287268a20.024491 20.024491 0 0 1-19.832562 12.731225l-98.075222-3.454704z"
										fill="#d66262" p-id="13390"></path>
								</svg>
							</i>
							现在购买 >

						</span>
						<span class="display-inline-block redfont font-bold ml-10 hover" @click="isShowShiyong = true">
							<i class="display-inline-block fl mt mr-1">
								<svg t="1732870807359" class="icon" viewBox="0 0 1131 1024" version="1.1"
									xmlns="http://www.w3.org/2000/svg" p-id="14527" width="20" height="20">
									<path
										d="M893.139604 105.628006L520.309287 478.371314l134.427734 134.688759 371.351177-373.091342zM624.11012 636.98734L496.556037 509.25924l-46.462401 170.362138 174.016484-42.54703zM1082.90458 22.361118a74.74008 74.74008 0 0 0-106.759113 0l-50.638797 50.638797 132.948594 134.340726 50.98683-51.247855a75.175121 75.175121 0 0 0 0-106.759113l-26.711531-26.885547z m-165.31566 921.330275H135.1238a123.986745 123.986745 0 0 1-53.597077-54.032119V188.54686a125.030844 125.030844 0 0 1 53.597077-54.380151h566.075622s20.968986-6.351602 20.968987-41.154898-20.968986-40.458833-20.968987-40.458833H105.715014A108.673294 108.673294 0 0 0 0 159.660124v759.668961a106.41108 106.41108 0 0 0 105.715014 104.40989h839.629535a109.195344 109.195344 0 0 0 106.237064-107.194154l2.175206-458.881468a59.078596 59.078596 0 0 0-42.547031-18.532756 50.638797 50.638797 0 0 0-40.023791 18.532756v431.821905a60.905769 60.905769 0 0 1-53.597077 54.032118z"
										fill="#d66262" p-id="14528"></path>
								</svg>
							</i>
							试用申请 ></span>
					</p>
					<!-- <p class=" font-bold hover" @click="isShowShiyong = true">先试用再决定购买，点击申请试用 > </p>
					<p class="">有问题,想咨询：<span class="hover" @click="openSmWindow('https://wpa1.qq.com/lwDa6cb4?_type=wpa&qidian=true')">在线客服 > </span></p> -->
					<p class="">电话咨询：<span>400 008 0586 </span> <span class="dil ml-2">0755-82571568
						</span></p>
					<p class="">微信咨询：</p>

				</div>
				<!-- 请 <a class="curp" href="https://wpa1.qq.com/4sai7BwX?_type=wpa&qidian=true"
						target="_blank">在线咨询 ></a> ，或微信咨询： -->
				<div class="right-slide-wechat mga por" :class="{ 'mt-2': type != 4 }">
					<div class="wechatfont">扫一扫 加微信咨询我们</div>
					<div class="wechat_codebox fl">
						<img src="../../assets/images/zixuncode-lss.png">
						<p class="tac">中投顾问 - 刘姗姗</p>
					</div>
					<div class="wechat_codebox fr">
						<img src="../../assets/images/zixuncode-bl.png">
						<p class="tac">中投顾问 - 白灵</p>
					</div>
				</div>
				<div class="text-center fz16 mt-2 download-text hover" @click="routerblank('/chain?id=44')"
					v-show="isShowDownFile">点击查看参考样版：半导体产业链图谱 ></div>
				<div class="text-center fz16 mt-2 download-text hover"
					@click="routerblank('/enterprises-free?id=300750&type=9')" v-show="isEnterpirseDetail">点击查看样本企业 >
				</div>

				<div v-if="type != 4">
					<p class="tac fz16 orangefont mt-2">联系电话:400 008 0586&nbsp;&nbsp;&nbsp;&nbsp;0755-82571568</p>
					<!-- <p class="tac mt-1 download-text fz16" v-show="isShowDownFile">点击下载：<a class="fz16 basefont" href="https://lian.ocn.com.cn/upload/pdf/202403/291129249208772.docx" target="downloadFile" download>新能源汽车产业链分析报告 ></a></p> -->
					<div class="text-center cur-pointer fz16 mt-2 basefont" @click="isShowShiyong = true">点击申请试用 ></div>
				</div>

			</div>
			<el-dialog class="localChain" :modal-append-to-body="false" append-to-body title=""
				:visible.sync="isShowShiyong" width="650px" top="15vh">
				<shiyong @handerChrend="handerChrend"></shiyong>
			</el-dialog>

		</div>
	</div>
</template>

<script>
import shiyong from "@/components/inc/shiyong.vue"

export default {
	name: 'freeUserTips',
	components: {
		shiyong,
	},
	props: {
		type: {
			type: Number,
			default: 1, //1试用账号 2免费账号 3正式账号但无操作权限
		},
		bgtype: {
			type: Number,
			default: 1,
			/*1为企业详情页供应商客户表格背景 2为拿地信息表格 3投资项目表格 4融资项目 5.对外投资 6.控制企业 7.专利信息8.软件著作权9.资质证书 10裁判文书 11司法案件 
			14为白色背景15.以商招商列表页 16.企业-城市关系计算器（本地关联企业）列表 17.企业-城市关系计算器（一级关系圈）列表 18.企业-城市关系计算器（二级关系圈计算结果）列表
			19.协会 20.商会 21.专业镇 22.股东信息 23.企业详情的相同投资机构 24.相同协会 25.相同商会 26.本地投资趋势 27.外商投资趋势 28.企业详情的企业画像（雷达图）
			29.企业详情经营状况 30.企业详情的股东信息 31.企业详情企业资质 32.企业详情研发信息 33.企业详情股权质押 34.企业详情风险预警 35.企业详情企业动态 36.投资机构详情投资领域
			37、投资机构详情投资画像 38.投资机构详情投资事件 39.企业详情产业标签 40.企业详情市场规模 41、产业链详情的市场规模 42、产业链详情的竞争格局 43、产业链详情的重点产业细分公司表格
			44.市场规模和竞争格局详情页的市场规模，45.市场规模和竞争格局详情页的竞争格局，
			*/
		},
		isShowDownFile: {  //是否显示下载模板链接
			type: Boolean,
			default: false,
		},
		isEnterpirseDetail: { type: Boolean, default: false },
		isShowPageTitle: { type: String, default: '' },
	},
	data() {
		return {
			userdata: {},
			isShowShiyong: false,
		}
	},

	created() {
		this.bus.$on('freeUserTips', (bool) => {
			// console.log('freeUserTips', bool);
			// this.isShowShiyong = !!bool;
		})
		this.userdata = this.getuseriformation();
		if (this.isShowPageTitle != '') {
			document.title = this.isShowPageTitle + '-产业研究大脑体验版';
		}
	},
	methods: {
		//在线客服打开新窗口
		openSmWindow(url) {
			try {
				window.open(url, "_blank", "height=600,width=800,top=200,left=200,status=yes,toolbar=no,menubar=no,resizable=yes,scrollbars=no,location=no,titlebar=no");
				_hmt.push(['_trackEvent', '报告', '咨询', '在线客服'])
			} catch (e) { }
			return false;
		},
		handerChrend(falg) {
			this.isShowShiyong = falg;

		}
	}
}
</script>

<style>
.tips-content {
	line-height: 36px;
	width: 392px;
	margin: 0 auto;
}

.vip-link:hover {
	cursor: pointer;
	text-decoration: underline;
	color: #3A66BE;

}

.download-text {
	color: #3A66BE;
}

.download-text a {
	text-decoration: underline;
}

.freeUserTips {
	width: 100%;
	height: 545px;
}

/*free-usertips-bg 在leftnav.less 搜索free-usertips-bg*/
.freeUserTips-opbg {
	width: 100%;
	height: 100%;
	background: rgba(255, 255, 255, .8);
	overflow: hidden;
}

.freeUserTips-con {
	width: 641px;
	height: 515px;
	margin: 20px auto;
	background: #fff6e4;
	border: 4px solid #f2c86f;
	overflow: hidden;
}
</style>